module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [
    [(!_vm.error) ? [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-3"
    }, [_c('campaign-summary'), (_vm.canOptOut) ? [_c('div', {
      staticClass: "row"
    }, [_c('gotu-nav-button', {
      staticClass: "btn-block mt-2 mx-3",
      attrs: {
        "theme": "default-cta",
        "className": "btn-block",
        "disabled": _vm.customAudienceOptOut
      },
      on: {
        "click": _vm.toggleCustomAudience
      }
    }, [_vm._v(_vm._s(_vm.$t('pos.campaign.custom-audience-toggle')))])], 1)] : _vm._e(), (_vm.canSuspendCampaign) ? [_c('div', {
      staticClass: "row"
    }, [_c('gotu-nav-button', {
      staticClass: "btn-block mt-2 mx-3",
      attrs: {
        "theme": "default-cta",
        "className": "btn-block"
      },
      on: {
        "click": _vm.suspendCampaign
      }
    }, [_vm._v(_vm._s(_vm.$t('pos.campaign.suspend-campaign-button')))])], 1)] : _vm._e(), (_vm.canResumeCampaign) ? [_c('div', {
      staticClass: "row"
    }, [_c('gotu-nav-button', {
      staticClass: "btn-block mt-2 mx-3",
      attrs: {
        "theme": "default-cta",
        "className": "btn-block"
      },
      on: {
        "click": _vm.resumeCampaign
      }
    }, [_vm._v(_vm._s(_vm.$t('pos.campaign.resume-campaign-button')))])], 1)] : _vm._e(), (_vm.permissions.includes("triggerCustomerAccessDetailsNotification")) ? _c('trigger-notification', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "wide": "wide",
        "kind": "campaign",
        "modelKey": _vm.current.code,
        "notification": _vm.NOTIFICATION_EVENTS.CAMPAIGN_CUSTOMER_ACCESS_DETAILS
      }
    }, [_vm._v(_vm._s(_vm.$t('pos.campaign.trigger-customer-access-details-notification')))]) : _vm._e()], 2), _c('div', {
      staticClass: "col-lg-6"
    }, [_c('campaign-step')], 1), (_vm.canViewProgress) ? _c('div', {
      staticClass: "col-lg-3"
    }, [_c('campaign-workflow')], 1) : _vm._e()])])] : _vm._e()]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b495070"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/campaign/Campaign.vue
// module id = 2060
// module chunks = 1